<ng-template #sidenavRef>
  <vex-sidenav [collapsed]="sidenavCollapsed$ | async"></vex-sidenav>
</ng-template>

<ng-template #toolbarRef>
  <vex-toolbar [hasShadow]="toolbarShadowEnabled$ | async" [mobileQuery]="!(isDesktop$ | async)" class="vex-toolbar"></vex-toolbar>
</ng-template>

<ng-template #footerRef>
<!--  <vex-footer *ngIf="isFooterVisible$ | async" class="vex-footer"></vex-footer>-->
</ng-template>


<vex-layout class="w-full"
  [footerRef]="footerRef"
  [toolbarRef]="toolbarRef"
  [sidenavRef]="sidenavRef">
</vex-layout>

<!--<main class="content">-->
<!--  <router-outlet></router-outlet>-->
<!--</main>-->

